import { render, staticRenderFns } from "./retrieve-pwd.vue?vue&type=template&id=1de2bf92&scoped=true"
import script from "./retrieve-pwd.vue?vue&type=script&lang=ts"
export * from "./retrieve-pwd.vue?vue&type=script&lang=ts"
import style0 from "./retrieve-pwd.vue?vue&type=style&index=0&id=1de2bf92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de2bf92",
  null
  
)

export default component.exports